export default __webpack_public_path__ + "static/logo-14-e2f5e50a9af5ab46f83d389a3827d95a.webp";